// extracted by mini-css-extract-plugin
export default {"giftCardPaymentLabel":"GiftCardPaymentLabel-module__giftCardPaymentLabel___3rzhn"};